import {
  TextField,
  TextArea as TextAreaInput,
  ValidationResult,
  FieldError,
} from "react-aria-components";
import { ChangeEvent } from "react";
import clsx from "clsx";

import Label from "./label";
import styles from "./textarea.module.css";

interface TextAreaInputProps {
  autocomplete?: string;
  autofocus?: boolean;
  className?: string;
  isRequired?: boolean;
  label: string;
  name: string;
  placeholder?: string;
  value?: string;
  onChange?: (ev: ChangeEvent<HTMLTextAreaElement>) => void;
  validate?: (value: string) => string | null;
  errorMessage?: string | ((validation: ValidationResult) => string);
}

function TextArea({
  autocomplete = "off",
  label,
  name,
  isRequired = false,
  autofocus = false,
  placeholder = "",
  value,
  className,
  onChange,
  validate = () => null,
  errorMessage,
}: TextAreaInputProps) {
  return (
    <TextField
      validate={validate}
      className={styles.textField}
      name={name}
      isRequired={isRequired}
    >
      <Label>{label}</Label>
      <TextAreaInput
        value={value}
        autoComplete={autocomplete}
        placeholder={placeholder}
        autoFocus={autofocus}
        className={clsx(styles.textArea, className)}
        onChange={onChange}
      />
      <FieldError className={styles.error}>{errorMessage}</FieldError>
    </TextField>
  );
}

export default TextArea;
